import { render, staticRenderFns } from "./myOders.vue?vue&type=template&id=b793cf78&scoped=true"
import script from "./myOders.vue?vue&type=script&lang=js"
export * from "./myOders.vue?vue&type=script&lang=js"
import style0 from "./myOders.vue?vue&type=style&index=0&id=b793cf78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b793cf78",
  null
  
)

export default component.exports